import { createClient } from '@/lib/supabase/client';

export interface CustomScenario {
  id: string;
  context: string;
  reflection: string;
  example: string;
  emotional_response: string;
  insight: string;
  action: string;
  submitted_by: string;
  created_at: string;
}

export interface NewCustomScenario {
  context: string;
  reflection: string;
  example: string;
  emotional_response: string;
  insight: string;
  action: string;
  submitted_by?: string;
}

export async function fetchCustomScenarios(): Promise<CustomScenario[]> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('custom_scenarios')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching custom scenarios:', error.message);
    return [];
  }
  return data || [];
}

export async function insertCustomScenario(
  scenario: NewCustomScenario
): Promise<{ data: CustomScenario | null; error: string | null }> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('custom_scenarios')
    .insert([scenario])
    .select()
    .single();

  if (error) {
    return { data: null, error: error.message };
  }
  return { data, error: null };
}
